import styled from 'styled-components';

export const Container = styled.div`
  border-color: ${(props) => props.theme.$primary};
  border-radius: 8px;

  .add-requirement-title {
    color: ${(props) => props.theme.$dark};
    font-size: 16px;
    font-weight: 600;
  }
`;
